import React, { useEffect, useState } from 'react';
import TextInput from '../../../../Shared/TextInput/TextInput';
import Checkbox from '../../../../Shared/CheckBox/Checkbox';
import { connect } from 'react-redux';

const LeadForm = (props) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState({ firstNameError: "", lastNameError: "", phoneNumberError: ""/*, checkboxTermsError: ""*/ });

  useEffect(() => {
    if (props.onSubmit) {
      let isValid = true;
      const isValidPhoneNumber = checkFieldValidation("phoneNumber", phoneNumber);
      const isValidFirstName = checkFieldValidation("firstName", firstName);
      const isValidLastName = checkFieldValidation("lastName", lastName);
      const isValidCheckbox = checkFieldValidation("checkbox", isChecked);
      if (!isValidPhoneNumber || !isValidFirstName || !isValidLastName || !isValidCheckbox) {
        isValid = false;
      }
      props.onValid({ isValid: isValid, data: { firstName: firstName, lastName: lastName, phoneNumber: phoneNumber } });
    }
  }, [props.onSubmit]);


  const onChange = (type, value) => {
    checkFieldValidation(type, value)
  }

  const checkFieldValidation = (type, value) => {
    let isValid = true;
    switch (type) {
      case "firstName":
        setFirstName(value);
        if (value?.trim().length < 2) {
          error.firstNameError = "אנא הכנס ערך תקין"
          setError({ ...error });
          isValid = false;
        }
        else {
          error.firstNameError = "";
          setError({ ...error });
        }
        break;
      case "lastName":
        setLastName(value);
        if (value?.trim().length < 2) {
          error.lastNameError = "אנא הכנס ערך תקין"
          setError({ ...error });
          isValid = false;
        }
        else {
          error.lastNameError = "";
          setError({ ...error });
        }
        break;
      case "phoneNumber":
        setPhoneNumber(value);
        if (!(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(value))) {
          error.phoneNumberError = "אנא הכנס ערך תקין"
          setError({ ...error });
          isValid = false;
        }
        else {
          error.phoneNumberError = ""
          setError({ ...error });
        }
    }
    return isValid;
  }

  return (
    <div className='sale-lead-form-address-wrapper' data-leadType={props.leadType}>
      <div className='form-wrapper'>
        <TextInput
          onChange={(e) => onChange("firstName", e.target.value)}
          value={firstName}
          className='text-input'
          placeholder='שם פרטי'
          type='text'
          autoComplete='off'
          required='required'
          error={error.firstNameError}
        />

        <TextInput
          onChange={(e) => onChange("lastName", e.target.value)}
          value={lastName}
          className='text-input'
          placeholder='שם משפחה'
          type='text'
          autoComplete='off'
          required='required'
          error={error.lastNameError}
        />

        <TextInput
          className='text-input'
          onChange={(e) => onChange("phoneNumber", e.target.value)}
          value={phoneNumber}
          placeholder='טלפון נייד'
          type='text'
          autoComplete='off'
          required='required'
          maxLength='10'
          error={error.phoneNumberError}
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    leadType: state.saleJetBlock.leadType,
    //other states
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadForm);
